import React from "react";
import Box, { BoxProps } from "../Box";

interface PropTypes extends BoxProps {
  children: React.ReactNode;
  style?: any;
}

function Card(props: PropTypes) {
  let { style, ...cardProps } = props;

  let inlineStyles = {
    shadowColor: "#777",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 6,
  };

  if (style) {
    inlineStyles = {
      ...inlineStyles,
      ...style,
    };
  }

  return (
    <Box style={inlineStyles} br="m" bg="common.white" {...cardProps}>
      {props.children}
    </Box>
  );
}

export default Card;
